var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask-quantity",class:{
    full: _vm.stockOfMask >= 200,
    few: _vm.stockOfMask < 200 && _vm.stockOfMask > 0,
    none: _vm.stockOfMask === 0
  }},[_c('h2',{staticClass:"mask-kind"},[_vm._t("default")],2),_c('h3',{staticClass:"quantity"},[_vm._v(_vm._s(_vm.stockOfMask)+" "),_c('span',[_vm._v("片")])])])}
var staticRenderFns = []

export { render, staticRenderFns }